import {Injectable} from '@angular/core';
import {Auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut} from '@angular/fire/auth';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {API_ENDPOINT} from '../shared/Constant/constant';
import {HttpParams} from '@angular/common/http';
import {Login} from '../shared/models/login';
import {Token} from '../shared/models/token';
import { Coupon, ValidationRequestDTO } from '../shared/models/coupon';
import {User} from '../shared/models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public baseUrl = environment.apiUrl;

  constructor(private auth: Auth, private http: HttpClient) {
  }

  /*register({email, password}: any) {
    return createUserWithEmailAndPassword(this.auth, email, password);
  }*/

 resetPassword(email: string): Observable<any> {
    const url = `${this.baseUrl}${API_ENDPOINT.RESET_PASSWORD}`;
    const body = { email: email };
    return this.http.post(url, body);
  }

  login(email: string, password: string): Promise<any> {
     const body = {
           email: email.toString(),
           password: password.toString()
         };
    return this.http.post<Login>(`${this.baseUrl}${API_ENDPOINT.LOGIN}`, body).toPromise();
    //return signInWithEmailAndPassword(this.auth, email, password);
  }

  validationLogin(token: string): Promise<any> {
     const body = {
           token: token.toString()
         };
    return this.http.post<Token>(`${this.baseUrl}${API_ENDPOINT.VALIDATION_LOGIN}`, body).toPromise();
    //return signInWithEmailAndPassword(this.auth, email, password);
  }

  register(email: string, password: string): Promise<any> {
     const body = {
           email: email.toString(),
           password: password.toString()
         };
    return this.http.post<Login>(`${this.baseUrl}${API_ENDPOINT.REGISTER}`, body).toPromise();
    //return signInWithEmailAndPassword(this.auth, email, password);
  }

  logout() {
    return signOut(this.auth);
  }

  saveUserPromotion(userId: string, email: string, promoCodeId: string): Observable<any> {
    const url = `${this.baseUrl}api/v1/userpromotion/save-coupon/${userId}/${email}/${promoCodeId}`;
    
    // 💡 Aquí está el cambio clave: agregamos { responseType: 'text' }
    // Esto le dice a Angular que la respuesta del servidor es texto plano, no JSON.
    return this.http.post(url, {}, { responseType: 'text' as 'json' });
  }

 //consulta el cupon el dialogo
  getPromoCodeById(id: string): Observable<any> {
    const url = `${this.baseUrl}api/v1/promocode/new/client/id/${id}`;
    return this.http.get(url);
  }
//consulta sus cupones el cliente
  getPersonalizedPromoCode(userId: string): Observable<Coupon> {
    const url = `${this.baseUrl}api/v1/userpromotion/new/client/personalized/${userId}`;
    return this.http.get<Coupon>(url);
  }

  /**
   * Valida un cupón de descuento consumiendo el microservicio de backend.
   * @param code El código del cupón a validar.
   * @param userId El ID del usuario que realiza la validación.
   * @param validationData El objeto DTO con la información de la compra.
   * @returns Un Observable con la respuesta del microservicio.
   */
  validatePromoCode(code: string, userId: string, validationData: ValidationRequestDTO): Observable<any> {
    const url = `${this.baseUrl}api/v1/promocode/client/validate/${code}`;
    const headers = new HttpHeaders().set('X-User-Id', userId);
    return this.http.post(url, validationData, { headers });
  }

  // This is the new method to implement the POST request for adding a user
  addUser(user: User): Observable<any> {
    const url = `${this.baseUrl}api/v1/user`;
    return this.http.post(url, user);
  }
}
